import { IllegalParkingReport } from "../types/illegalParkingReport";

// Using the working API Gateway URL instead of proxy
const API_BASE_URL = 'https://y00ey592mh.execute-api.us-east-1.amazonaws.com/Production';

export interface UploadResult {
  reportId: string;
  imageUrl: string;
  status?: string;
}

export interface ReportFormData {
  reportId: string;
  licensePlate: string;
  state: string;
  geoLocation: string;
  reason: string;
  description: string;
}

export interface MapBounds {
  south: number;
  north: number;
  west: number;
  east: number;
}

export const api = {
  // Upload a photo and create a new report
  uploadPhoto: async (file: Blob): Promise<UploadResult> => {
    const formData = new FormData();
    formData.append('file', file, 'upload.jpg');

    const response = await fetch(`${API_BASE_URL}/illegal-parking-report`, {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`Upload failed with status ${response.status}`);
    }

    return response.json();
  },

  // Get report status
  getReportStatus: async (reportId: string): Promise<{ status: string }> => {
    const response = await fetch(
      `${API_BASE_URL}/illegal-parking-report?reportId=${reportId}`,
      { method: 'GET' }
    );

    if (!response.ok) {
      throw new Error('Failed to check report status');
    }

    return response.json();
  },

  // Submit report details
  submitReport: async (formData: ReportFormData): Promise<void> => {
    const response = await fetch(`${API_BASE_URL}/illegal-parking-report`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    });

    if (!response.ok) {
      const responseText = await response.text();
      throw new Error(`Failed to update report: ${response.status} ${responseText}`);
    }
  },

  // Get nearby illegal parking reports
  getNearbyReports: async (bounds: MapBounds): Promise<IllegalParkingReport[]> => {
    // Ensure full precision by using toFixed(6) for 6 decimal places (precision of ~1 meter)
    const params = new URLSearchParams({
      south: bounds.south.toFixed(6),
      north: bounds.north.toFixed(6),
      west: bounds.west.toFixed(6),
      east: bounds.east.toFixed(6)
    });

    const response = await fetch(`${API_BASE_URL}/illegal-parking-report/nearby?${params}`, {
      method: 'GET'
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch nearby reports: ${response.status}`);
    }

    return response.json();
  }
}; 